<template>
    <div>
        <v-simple-table>
            <thead>
                <tr>
                    <th class="text-left">
                        Прибор учета
                    </th>
                    <th class="text-right" width="85">
                        Предыдущее<br>показание
                    </th>
                    <th class="text-right" width="170">
                        Текущее<br>показание
                    </th>
                    <th class="text-right" width="130">
                        Расход
                    </th>
                </tr>
            </thead>
            <tbody>

                <sgwg-one-form-counters-item ref="counters" v-for="counter in counters" :key="counter.id"
                    :counter="counter" :hide-check-date="hideCheckDate" />

            </tbody>

        </v-simple-table>


        <v-divider class="mb-4" />


        <v-tabs-items v-model="tabs">

            <v-tab-item>
                <div class="d-flex align-end px-4">

                    <v-spacer />

                    <v-btn depressed color="primary" x-large @click="startSendReadings">Отправить</v-btn>
                </div>

            </v-tab-item>

            <v-tab-item>

                <div class="d-flex align-center px-4">


                    <v-icon color="warning" x-large class="mr-3">mdi-alert</v-icon>
                    <div>

                        По {{ warningCount == 1 ? 'одной услуге' : 'нескольким услугам' }} подано слишком большое
                        показание. Все равно продолжить?

                    </div>

                    <v-spacer />

                    <v-btn outlined color="primary" x-large @click="sendReadings" class="mr-3">Продолжить
                    </v-btn>
                    <!-- style="background-color: #17C1FF; color: #FFFFFF" -->
                    <v-btn depressed color="primary" x-large @click="tabs = 0">Отмена
                    </v-btn>

                </div>

            </v-tab-item>



        </v-tabs-items>

    </div>
</template>

<script>
    import SgwgOneFormCountersItem from './SgwgOneFormCountersItem'

    export default {
        props: {
            counters: {
                type: Array,
                require: true
            },
            hideCheckDate: {
                type: Boolean,
                require: false,
                default: false
            }
        },
        components: {
            SgwgOneFormCountersItem
        },
        data() {
            return {
                sending: false,
                readings: {},
                tabs: 0,
                warningCount: 0
            }
        },
        methods: {


            startSendReadings() {
                if (this.sending) {
                    console.warn("reading already sending...")
                    return
                }

                if (!this.$refs.counters.some(counter => counter.canReading)) {
                    console.warn('readings is closed for all devices')
                    return
                }

                if (this.$refs.counters.some(counter => counter.isConsumError())) {
                    console.warn('one of readings has consumption error')
                    return
                }

                if (!this.$refs.counters.some(counter => counter.changed)) {
                    console.warn('without changes')
                    return
                }

                this.warningCount = this.$refs.counters.filter(counter => counter.isConsumWarning()).length
                if (this.warningCount > 0) {
                    this.tabs = 1
                    return
                }

                this.sendReadings()
            },


            sendReadings() {


                if (this.sending) {
                    return
                }

                let devices = this.$refs.counters.filter(counter => counter.canReading && counter.changed)
                
                
                let readings = devices.map(counter => {
                     return {
                            meter: counter.guid,
                            reading: counter.current
                        }
                    })

                this.tabs = 0
                this.sending = true

                this.$eventBus.$emit('loader:show', {
                    loaderText: "Передача показаний"
                })

                this.$api.meterReading(readings)
                    .then(result => {
                        
                        this.$emit('save-readings', { result, readings } )
                    })
                    .catch(error => {

                        switch (error.code) {
                            case 10:
                            case 11:

                                /*     this.hasMessage = true */
                                /*       this.message = err.message */


                                this.$eventBus.$emit('modal:dialog', {
                                    props: {
                                        message: error.message
                                    }
                                })

                                break;
                                /*          case 20:
                                             this.showCaptcha()
                                             break; */
                                /*              case 30: 
      
                               break;  */
                            case 99:


                                this.$eventBus.$emit('modal:dialog', {
                                    props: {
                                        message: "Сервис недоступен. Повторите попытку позже."
                                    }
                                })

                            default:
                                break;
                        }
                    })
                    .finally(() => {
                        this.sending = false
                        this.$eventBus.$emit('loader:hide')
                    })
            },
        }
    }
</script>

<style>

</style>